import ExportFilter from './ExportFilter';
import { hasConflict } from './internal';
import { FormGroup } from '../widgets';
import { Checkbox } from '../widgets/beauty/input';
import { CollectionFilter, FilterType } from './Contracts';

export interface ExportFilterListProps {
  name: string;
  enabled: boolean;
  filters: CollectionFilter[];
  onEnabledChange: (name: string) => void;
  onFilterChange: (collection: string, filter: string, value: any) => void;
}

const ExportFilterList: React.FC<ExportFilterListProps> = ({
  name,
  filters,
  enabled,
  onEnabledChange,
  onFilterChange
}: ExportFilterListProps) => {

  const sorted = [
    ...filters.filter(f => f.type === FilterType.Text),
    ...filters.filter(f => f.type === FilterType.Select),
    ...filters.filter(f => f.type === FilterType.SelectLong),
    ...filters.filter(f => f.type === FilterType.Date),
    ...filters.filter(f => f.type === FilterType.Boolean),
  ]
  return (
    <FormGroup className="row mt-3">
      <div className="col-12">
        <Checkbox
          text={name}
          onChange={() => onEnabledChange(name)}
          checked={enabled} />
      </div>
      {filters.length > 0 ?
        <div className="col-12">
          <ul className="backup-filter-list row">
            {sorted.map((f: any, i) => (
              <ExportFilter
                key={`${i}`}
                {...f}
                disabled={!enabled || hasConflict(sorted, f)}
                onChange={(value) => onFilterChange(name, f.name, value)}
              />
            ))}
          </ul>
          <hr style={{ width: 'calc(100%)' }} />
        </div>
        :
        <hr style={{ width: 'calc(100% - 30px)' }} />
      }

    </FormGroup>
  );
}

export default ExportFilterList;
